import FallBack from 'components/Fallback'
import BaseLayout from 'components/Layout'
import dynamic from 'next/dynamic'
import { Suspense, lazy } from 'react'

const HomePage = dynamic(() => import('components/home'), {
  loading: () => <FallBack />,
  ssr: false,
})

export default function Home() {
  return (
    <BaseLayout>
      <Suspense>
        <HomePage />
      </Suspense>
    </BaseLayout>
  )
}
